import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

export default {
    name: 'bank',
    state: {
        bankList: []
    },
    getters: {
        getBank: state => {
            return state.bankList
        },
    },
    mutations: {
        ADD_BANK: (state, payload) => {
            state.bankList = payload
        }
    },
    actions: {
        Fetch_Bank(store) {
            return axios({
                method: "get",
                url: "./json/bank.json"
            }).then(response => {
                store.commit('ADD_BANK', response.data);
            }).catch(err => {
                return err
            });
        },
        FetchBankDB(store, { auth, params }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bank",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        FetchEditBank(store, { auth, params }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bank",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        id_bank_account: params,
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        FetchDataInput(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bank/data_input",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        PostBank(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + 'bank',
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": 'application/json',
                    },
                })
                    .then(({ data, status }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        PutBank(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "put",
                    url: process.env.VUE_APP_SERVICEURL + 'bank',
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": 'application/json',
                    },
                })
                    .then(({ data, status }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    }
}